export default __webpack_public_path__ + "static/media/2.3dbc6d3b.webp";